import { LogActionEnum } from 'src/app/shared/enums/log-action.enum';
import { IPlannedActivityAdminLogFieldChange } from '../models/planned-activities/planned-activity-admin-log.model';

const PLANNED_ACTIVITY_ADMIN_LOG_PREVIOUS_CURRENT_FIELDS: Record<
  string,
  { previousLabelKey: string; currentLabelKey: string }
> = {
  activity: {
    previousLabelKey: 'adminLogPreviousActivity',
    currentLabelKey: 'adminLogCurrentActivity',
  },
  from: {
    previousLabelKey: 'adminLogPreviousFrom',
    currentLabelKey: 'adminLogCurrentFrom',
  },
  to: {
    previousLabelKey: 'adminLogPreviousTo',
    currentLabelKey: 'adminLogCurrentTo',
  },
  position: {
    previousLabelKey: 'adminLogPreviousPosition',
    currentLabelKey: 'adminLogCurrentPosition',
  },
  department: {
    previousLabelKey: 'adminLogPreviousDepartment',
    currentLabelKey: 'adminLogCurrentDepartment',
  },
  tripName: {
    previousLabelKey: 'adminLogPreviousTrip',
    currentLabelKey: 'adminLogCurrentTrip',
  },
  trip: {
    previousLabelKey: 'adminLogPreviousTrip',
    currentLabelKey: 'adminLogCurrentTrip',
  },
};

export interface IPlannedActivityAdminLogFieldChangeRow {
  labelKey?: string;
  value: string;
  fieldName?: string;
  translationKey?: string;
}

export function buildPlannedActivityAdminLogFieldChangeRows(
  fieldsChanged: IPlannedActivityAdminLogFieldChange[],
  action: string
): IPlannedActivityAdminLogFieldChangeRow[] {
  return (fieldsChanged ?? []).flatMap((fieldChange): IPlannedActivityAdminLogFieldChangeRow[] => {
    const previousCurrentConfig =
      PLANNED_ACTIVITY_ADMIN_LOG_PREVIOUS_CURRENT_FIELDS[fieldChange.fieldName];

    if (previousCurrentConfig && fieldChange.oldValue) {
      return [
        {
          labelKey: previousCurrentConfig.previousLabelKey,
          value: fieldChange.oldValue,
          fieldName: fieldChange.fieldName,
        },
        {
          labelKey: previousCurrentConfig.currentLabelKey,
          value: fieldChange.value,
          fieldName: fieldChange.fieldName,
        },
      ];
    }

    return [
      {
        value: fieldChange.value,
        fieldName: fieldChange.fieldName,
        translationKey: resolvePlannedActivityAdminLogTranslationKey(action),
      },
    ];
  });
}

function resolvePlannedActivityAdminLogTranslationKey(action: string): string {
  if (action === LogActionEnum.Created) {
    return 'hasBeenAssignedAValueOf';
  }
  if (action === LogActionEnum.Edited) {
    return 'hasBeenUpdated';
  }
  return 'changedTo';
}
